<!--
 * @Author: shen
 * @Date: 2022-01-06 09:54:07
 * @FilePath: \56Xykt\src\page\xSchool\ITC\itcIndex.vue
 * @LastEditTime: 2025-02-19 14:50:06
 * @LastEditors: Do not edit
-->
<template>
    <div class="wlx-system-manager-wrapper">
        <div class="system-manager-head clearfix">
            <div class="school-logo-con fl">
                <img :src="schoolLogo" alt class="logo-img" />
            </div>
            <div class="fr system-stu-info-con clearfix">
                <router-link class="fl enter-to-back-home" :to="{ name: 'xHome' }" target="_blank">
                    <i class="wl-icon-shouye2"></i>
                    <span>前台首页</span>
                </router-link>
                <div class="head-user-logo-con fl">
                    <img :src="userLogo" alt />
                </div>
                <div class="fl head-user-info">
                    <span>{{ userInfo.userName }}</span>
                </div>
                <div class="fr get-out-sys" @click="outLogin">
                    <i class="wl-icon-dianyuan"></i>
                </div>
            </div>
        </div>
        <div class="system-manager-content clearfix">
            <div class="system-menu-con fl">
                <ul>
                    <li>
                        <router-link :to="{ name: 'assessApplyTea' }" class="clearfix menu-li-item">
                            <i class="wl-icon-zhengshu1"></i>
                            考核站点申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'itcBatch' }" class="clearfix menu-li-item">
                            <i class="wl-icon-zhengshu1"></i>
                            IFPSM 证书互认申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'projectList' }" class="clearfix menu-li-item">
                            <i class="wl-icon-zhengshu1"></i>
                            项目申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{ name: 'applyITC' }" class="clearfix menu-li-item">
                            <i class="wl-icon-zhengshu1"></i>
                            ITC换证申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li> -->
                </ul>
            </div>
            <div class="system-manager-con-main fr">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
export default {
    data() {
        return {
            schoolLogo: require("assets/images/clpp-logo.png"),
            userLogo: require("assets/images/default_avatar3.png"),
            certificateInfo: {},
            routerActive: this.$route.path,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
    },
    props: {
        certificateId: {
            type: String,
            default: "",
        },
    },
    created() {
        var that = this;
        if (localStorage["userId"] !== undefined) {
            that.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
        }
    },
    methods: {
        backToHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        outLogin() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/outLogin").then(function (rst) {
                if (rst.code > 0) {
                    that.$store.commit(MU_UPATE_AUTH, null);
                    that.$router.push({
                        name: "xHome",
                    });
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss"></style>
